import * as client from "../../../client";

export type SelectedModel = "icm" | "rms" | "rms_elt" | "spatialkat";

export type PerilCode =
  | "PWH"
  | "PSH"
  | "PPH"
  | "PES"
  | "PSL"
  | "PFF"
  | "PFL"
  | "PWB"
  | "PWW"
  | "PWT";

export const PERIL_OPTIONS: { label: string; value: PerilCode }[] = [
  { label: "Hurricane - Wind Only", value: "PWH" },
  { label: "Hurricane - Storm Surge", value: "PSH" },
  { label: "Earthquake - Ground Shake", value: "PES" },
  { label: "Earthquake - Sprinkler Leak.", value: "PSL" },
  { label: "Earthquake - Fire Following", value: "PFF" },
  { label: "Inland Flood", value: "PFL" },
  { label: "Wildfire", value: "PWB" },
  { label: "Winter Storm", value: "PWW" },
  { label: "Severe Thunderstorm", value: "PWT" },
];

export const PERIL_DISPLAY_NAMES = new Map<string, string>(
  PERIL_OPTIONS.map((o) => [o.value, o.label])
);

// RMS EP Curve constants: we have more of this data, but keeping it limited
// for the time being since the table gets busy.
export const RETURN_PERIODS = [100, 250];

// Enriched RMS layer with matched layer_id from report config
export interface RmsLayerResult extends client.CatLayerResult {
  layer_id: string | null;
}

export interface LayerPerilRow {
  layer: string;
  peril: string;
  aal: number | null;
  pml_100: number | null;
  pml_250: number | null;
  pml_1000: number | null;
  isFirstInGroup?: boolean;
}

export const getPerilDisplayName = (perilCode: string): string => {
  const displayName = PERIL_DISPLAY_NAMES.get(perilCode) ?? perilCode;
  if (
    perilCode.toLowerCase() === "combined" ||
    displayName.toLowerCase() === "combined"
  ) {
    return "Layer Total";
  }
  return displayName;
};

export const isLayerTotalPeril = (perilCode: string): boolean =>
  getPerilDisplayName(perilCode).toLowerCase() === "layer total";
